import { render } from "./BannerBlue.vue?vue&type=template&id=d96aa000"
import script from "./BannerBlue.vue?vue&type=script&lang=js"
export * from "./BannerBlue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__